// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__5lKe4","modalFooterButton":"ModalNotes_modalFooterButton__37PKz"};